const localHopSkipConfig: IHopSkipConfig = {
	clientRoot: 'http://localhost:3000',
	api: {
		environment: 'local',
		host: 'https://bookdev.myhopskip.com', // "http://localhost:7071"
		hostnamesuffix: 'dev',
		proxies: {
			search: {
				host: 'https://drbl-mvp-search-dev.search.windows.net',
				query: '&api-key=71EEC9B6AB0FBA3C4F6B0F25B873E14C'
			},
			plat: { localPort: 7072, local: false },
			rpt: { localPort: 7073, local: false },
			contract: { localPort: 7074, local: false },
			ai: { localPort: 7075, local: false },
			promo: { localPort: 7076, local: false },
			msg: { localPort: 7077, local: false },
			doc: { localPort: 7078, local: false },
			imex: { localPort: 7079, local: false },
			alx: { localPort: 7080, local: false },
			noti: { localPort: 7081, local: false },
			rtw: { localPort: 7082, local: false },
			img: { localPort: 7083, local: false },
			sourcing: { localPort: 7084, local: false },
			selling: { localPort: 7085, local: false, includePath: true }
		}
	},
	imagesEndpoint: {
		url: 'https://apibanfog6k5b4l6.blob.core.windows.net/images'
	},
	auth: {
		loginDomain: 'https://hopskip.b2clogin.com', // "https://localhost:7072/api",
		tenant: 'hopskip.onmicrosoft.com',
		policyEnvironment: 'Staging',
		clientId: '83e6963e-14ec-4824-b03f-65fc4d131ddc',
		scopeIdentifierUri: 'https://hopskip.onmicrosoft.com/mvpapi',
		logLevel: 'error'
	},
	appInsights: {
		instrumentationKey: '63fee93c-c15a-49e8-a31d-9522a4f95112',
		connectionString:
			'InstrumentationKey=63fee93c-c15a-49e8-a31d-9522a4f95112;IngestionEndpoint=https://eastus-6.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/'
	},
	search: {
		serviceName: 'drbl-mvp-search-dev',
		radiusKm: 120
	},
	hotel: {
		maxRating: 5,
		default: 3
	},
	googleAnalytics: {
		key: 'UA-1938068-6'
	},
	googleMaps: {
		key: 'AIzaSyCreCKz1kNmYcls7qcljTMok1ORik0ZaBM'
	},
	hopSkip: {
		iataCode: '39772994',
		iataAgency: 'HOPSKIP INC'
	},
	stripe: {
		publishableKey: 'pk_test_ZNk80kgugkHhmA5yPgg2VeC8000g1pTRvO'
	},
	supplierRfpPdfExceptions: {
		propertySeller: []
	}
}

const developmentHopSkipConfig: IHopSkipConfig = {
	clientRoot: 'https://appdev.myhopskip.com',
	api: {
		environment: 'Dev',
		host: 'https://bookdev.myhopskip.com',
		hostnamesuffix: 'dev',
		proxies: {
			search: {
				host: 'https://drbl-mvp-search-dev.search.windows.net',
				query: '&api-key=71EEC9B6AB0FBA3C4F6B0F25B873E14C'
			},
			plat: {},
			rpt: {},
			contract: {},
			ai: {},
			promo: {},
			msg: {},
			doc: {},
			imex: {},
			alx: {},
			noti: {},
			rtw: {},
			img: {},
			sourcing: {},
			selling: { includePath: true }
		}
	},
	imagesEndpoint: {
		url: 'https://apibanfog6k5b4l6.blob.core.windows.net/images'
	},
	auth: {
		loginDomain: 'https://hopskip.b2clogin.com',
		tenant: 'hopskip.onmicrosoft.com',
		policyEnvironment: 'Staging',
		clientId: '83e6963e-14ec-4824-b03f-65fc4d131ddc',
		scopeIdentifierUri: 'https://hopskip.onmicrosoft.com/mvpapi',
		logLevel: 'verbose'
	},
	appInsights: {
		instrumentationKey: '63fee93c-c15a-49e8-a31d-9522a4f95112',
		connectionString:
			'InstrumentationKey=63fee93c-c15a-49e8-a31d-9522a4f95112;IngestionEndpoint=https://eastus-6.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/'
	},
	search: {
		serviceName: 'drbl-mvp-search-dev',
		radiusKm: 120
	},
	hotel: {
		maxRating: 5,
		default: 3
	},
	googleAnalytics: {
		key: 'UA-1938068-6'
	},
	googleMaps: {
		key: 'AIzaSyCreCKz1kNmYcls7qcljTMok1ORik0ZaBM'
	},
	hopSkip: {
		iataCode: '39772994',
		iataAgency: 'HOPSKIP INC'
	},
	stripe: {
		publishableKey: 'pk_test_ZNk80kgugkHhmA5yPgg2VeC8000g1pTRvO'
	},
	supplierRfpPdfExceptions: {
		propertySeller: []
	}
}

const qaHopSkipConfig: IHopSkipConfig = {
	clientRoot: 'https://appqasbx.myhopskip.com',
	api: {
		environment: 'Qa',
		host: 'https://bookqa.myhopskip.com',
		hostnamesuffix: 'qasbx',
		proxies: {
			search: {
				host: 'https://drbl-mvp-search-qasbx.search.windows.net',
				query: '&api-key=E08FC048C092313DA781E72F916353B3'
			},
			plat: {},
			rpt: {},
			contract: {},
			ai: {},
			promo: {},
			msg: {},
			doc: {},
			imex: {},
			alx: {},
			noti: {},
			rtw: {},
			img: {},
			sourcing: {},
			selling: { includePath: true }
		}
	},
	imagesEndpoint: {
		url: 'https://apiecfpesz2e4zaw.blob.core.windows.net/images'
	},
	auth: {
		loginDomain: 'https://hopskip.b2clogin.com',
		tenant: 'hopskip.onmicrosoft.com',
		policyEnvironment: 'Staging',
		clientId: '83e6963e-14ec-4824-b03f-65fc4d131ddc',
		scopeIdentifierUri: 'https://hopskip.onmicrosoft.com/mvpapi',
		logLevel: 'info'
	},
	appInsights: {
		instrumentationKey: '9f9333f3-6515-4da9-a201-5b9dda2f68d2',
		connectionString:
			'InstrumentationKey=9f9333f3-6515-4da9-a201-5b9dda2f68d2;IngestionEndpoint=https://eastus-5.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/'
	},
	search: {
		serviceName: 'drbl-mvp-search-qasbx',
		radiusKm: 120
	},
	hotel: {
		maxRating: 5,
		default: 3
	},
	googleAnalytics: {
		key: 'UA-1938068-6'
	},
	googleMaps: {
		key: 'AIzaSyCreCKz1kNmYcls7qcljTMok1ORik0ZaBM'
	},
	hopSkip: {
		iataCode: '39772994',
		iataAgency: 'HOPSKIP INC'
	},
	stripe: {
		publishableKey: 'pk_test_ZNk80kgugkHhmA5yPgg2VeC8000g1pTRvO'
	},
	supplierRfpPdfExceptions: {
		propertySeller: []
	}
}

const demoHopSkipConfig: IHopSkipConfig = {
	clientRoot: 'https://appdemo.myhopskip.com',
	api: {
		environment: 'Demo',
		host: 'https://bookdemo.myhopskip.com',
		hostnamesuffix: 'demo',
		proxies: {
			search: {
				host: 'https://drbl-mvp-search-demo.search.windows.net',
				query: '&api-key=B25C7A18EEE6D43B69E39EBAB7EB723C'
			},
			plat: {},
			rpt: {},
			contract: {},
			ai: {},
			promo: {},
			msg: {},
			doc: {},
			imex: {},
			alx: {},
			noti: {},
			rtw: {},
			img: {},
			sourcing: {},
			selling: { includePath: true }
		}
	},
	imagesEndpoint: {
		url: 'https://apid53gxyv2ebzyg.blob.core.windows.net/images'
	},
	auth: {
		loginDomain: 'https://hopskip.b2clogin.com',
		tenant: 'hopskip.onmicrosoft.com',
		policyEnvironment: 'Staging',
		clientId: '83e6963e-14ec-4824-b03f-65fc4d131ddc',
		scopeIdentifierUri: 'https://hopskip.onmicrosoft.com/mvpapi',
		logLevel: 'error'
	},
	appInsights: {
		instrumentationKey: '3bec4a6f-8f75-49f7-8445-39c32bef15b0',
		connectionString:
			'InstrumentationKey=3bec4a6f-8f75-49f7-8445-39c32bef15b0;IngestionEndpoint=https://eastus-6.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/'
	},
	search: {
		serviceName: 'drbl-mvp-search-demo',
		radiusKm: 120
	},
	hotel: {
		maxRating: 5,
		default: 3
	},
	googleAnalytics: {
		key: 'UA-1938068-6'
	},
	googleMaps: {
		key: 'AIzaSyCreCKz1kNmYcls7qcljTMok1ORik0ZaBM'
	},
	hopSkip: {
		iataCode: '39772994',
		iataAgency: 'HOPSKIP INC'
	},
	stripe: {
		publishableKey: 'pk_test_ZNk80kgugkHhmA5yPgg2VeC8000g1pTRvO'
	},
	supplierRfpPdfExceptions: {
		propertySeller: []
	}
}

const productionHopSkipConfig: IHopSkipConfig = {
	clientRoot: 'https://app.myhopskip.com',
	api: {
		environment: 'Prod',
		host: 'https://book.myhopskip.com',
		hostnamesuffix: 'prod',
		proxies: {
			search: {
				host: 'https://drbl-mvp-search-prod.search.windows.net',
				query: '&api-key=9A278350BB2330B4187CB4C4BF10BCB4'
			},
			plat: {},
			rpt: {},
			contract: {},
			ai: {},
			promo: {},
			msg: {},
			doc: {},
			imex: {},
			alx: {},
			noti: {},
			rtw: {},
			img: {},
			sourcing: {},
			selling: { includePath: true }
		}
	},
	imagesEndpoint: {
		url: 'https://apid53gxyv2ebzyg.blob.core.windows.net/images'
	},
	auth: {
		loginDomain: 'https://hopskip.b2clogin.com',
		tenant: 'hopskip.onmicrosoft.com',
		policyEnvironment: 'Prod',
		clientId: '83e6963e-14ec-4824-b03f-65fc4d131ddc',
		scopeIdentifierUri: 'https://hopskip.onmicrosoft.com/mvpapi',
		logLevel: 'error'
	},
	appInsights: {
		instrumentationKey: '342d7ca9-8a79-4e5e-aefb-f148c0294343',
		connectionString:
			'InstrumentationKey=342d7ca9-8a79-4e5e-aefb-f148c0294343;IngestionEndpoint=https://eastus-6.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/'
	},
	search: {
		serviceName: 'drbl-mvp-search-prod',
		radiusKm: 120
	},
	hotel: {
		maxRating: 5,
		default: 3
	},
	googleAnalytics: {
		key: 'UA-1938068-6'
	},
	googleMaps: {
		key: 'AIzaSyCreCKz1kNmYcls7qcljTMok1ORik0ZaBM'
	},
	hopSkip: {
		iataCode: '39772994',
		iataAgency: 'HOPSKIP INC'
	},
	stripe: {
		publishableKey: 'pk_live_tmhXW3WobxnaBdIWTnrbvGRa001byDGWg5'
	},
	supplierRfpPdfExceptions: {
		propertySeller: []
	}
}

interface IHopSkipConfig {
	clientRoot?: string
	api: {
		environment: string
		host: string
		hostnamesuffix: string
		proxies: Record<
			string,
			{
				host?: string
				query?: string
				includePath?: boolean
				localPort?: number
				local?: boolean
			}
		>
	}
	imagesEndpoint: {
		url: string
	}
	auth: {
		loginDomain: string
		tenant: string
		policyEnvironment: string
		clientId: string
		scopeIdentifierUri: string
		logLevel: string
	}
	appInsights: {
		instrumentationKey: string
		connectionString: string
	}
	search: {
		serviceName: string
		radiusKm: number
	}
	hotel: {
		maxRating: number
		default: number
	}
	googleAnalytics: {
		key: string
	}
	googleMaps: {
		key: string
	}
	hopSkip: {
		iataCode: string
		iataAgency: string
	}
	stripe: {
		publishableKey: string
	}
	supplierRfpPdfExceptions: {
		propertySeller: string[]
	}
}

export {
	demoHopSkipConfig,
	developmentHopSkipConfig,
	localHopSkipConfig,
	productionHopSkipConfig,
	qaHopSkipConfig
}
export type { IHopSkipConfig }

export const intentSource = 'https://hopskip.com/web-client/2.0'
